import React, { FC, ReactNode } from "react";
import { View } from "@tarojs/components";
import classname from "classnames";
import { XHComponentCommonProps } from "../../types";
import "./index.scss";
import Loading, { LoadingProps } from "../Loading";
import NavBar from "../NavBar";

export interface PageProps extends XHComponentCommonProps {
  loading?: boolean;
  mask?: LoadingProps["mask"];
  tip?: ReactNode;
  loadingColor?: string;
  /**
   * @supported 小程序
   * @default false
   */
  customNavBar?: boolean;
  onBack?: () => void;
  title?: string;
  leftIcon?: boolean;
  rightIcon?: ReactNode;
  navBarBorder?: boolean;
}

const Page: FC<PageProps> = props => {
  const {
    children,
    loading = false,
    className = "",
    mask = "normal",
    tip = "加载中",
    loadingColor = "#FFF",
    customNavBar = false,
    title = "",
    ...rest
  } = props;

  const PROJECT = process.env.PROJECT || "default";

  const classObj = classname("xh-page", className, {
    flex: process.env.TARO_ENV !== "h5" && customNavBar,
  });

  return (
    <View
      className={classObj}
      // @ts-ignore
      dataTrackId="NavBar"
    >
      {process.env.TARO_ENV !== "h5" && customNavBar && (
        <NavBar title={title} {...rest} />
      )}
      {PROJECT === "frigg" && <NavBar title={title} {...rest} />}
      {loading && (
        <View className="loading-wrapper">
          <Loading mask={mask} tip={tip} color={loadingColor} />
        </View>
      )}
      {customNavBar && process.env.TARO_ENV !== "h5" ? (
        <View className="xh-page-content">{children}</View>
      ) : (
        children
      )}
    </View>
  );
};

export default Page;
